import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import StarsBackground from "@/components/landing/StarsBackground";

// Content sections render eagerly so SSG produces full HTML for crawlers
// + AI agents. Bundle-split lost meaning when we moved to SSG — HTML
// paints first, JS hydrates in parallel.
import ProductPillars from "@/components/landing/ProductPillars";
import FreshnessShowcase from "@/components/landing/FreshnessShowcase";
import PricingTeaser from "@/components/landing/PricingTeaser";
import FAQ from "@/components/landing/FAQ";
import FooterCTA from "@/components/landing/FooterCTA";

const Index = () => {
  // Theme class is applied by the synchronous inline script in `index.html`
  // before React mounts (FOUC-safe). No useEffect needed here.

  return (
    <div className="min-h-dvh bg-background relative">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded focus:bg-background focus:px-3 focus:py-2 focus:text-foreground focus:shadow-lg focus:ring-2 focus:ring-ring"
      >
        Skip to main content
      </a>
      <StarsBackground />
      <div className="relative z-10">
        <Navbar />
        <main id="main-content">
          <Hero />
          <FreshnessShowcase />
          <ProductPillars />
          <PricingTeaser />
          <FAQ />
          <FooterCTA />
        </main>
      </div>
    </div>
  );
};

// SSG: consumed by entry-server.tsx + scripts/prerender.mjs to inject
// per-page <title>, <meta name="description">, canonical, OG, and
// Twitter tags into the prerendered HTML.
export const head = {
  title: "AntAtlas — The Live Context Layer for AI Coding Agents",
  description:
    "AntAtlas maps how features work across repositories and gives AI coding agents task-specific, source-backed context without repeated codebase exploration.",
  path: "/",
};

export default Index;
